/* eslint-disable no-restricted-syntax */
export const taxTypes = {
  noTax: {
    id: "noTax",
    value: "notax",
    name: "No Tax Apply",
    amount: 0,
    percentPoint: 0,
    description: "No Tax Apply",
    default: true
  },
  tax6: {
    id: 'tax6',
    value: "tax6",
    name: "6% Tax",
    amount: 0,
    percentPoint: 6.0,
    description: "6% Tax",
    default: false
  },
  tax10: {
    id: 'tax10',
    value: "tax10",
    name: "10% Tax",
    amount: 0,
    percentPoint: 10.0,
    description: "10% Tax",
    default: false
  }
}

export const getDefaultTaxType = () => {

  for (const [key, value] of Object.entries(taxTypes)) {
    // console.log(`${key}: ${value}`);
    if (value.default) return value
  }

  return false
}

const getArray = () => {

  let array = [];

  for (const [key, value] of Object.entries(taxTypes)) {
    array.push(value)
  }

  return array
}

export const taxTypesArray = getArray()

export const getTaxTypeByValue = (val) => {

  for (const [key, value] of Object.entries(taxTypes)) {
    // console.log(`${key}: ${value}`);
    if (value.value === val) return value
  }

  return false
}